import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Container, Inner, Image, User } from './styles';

export default function Section05VideoItem({
  video,
  img_video,
  text,
  user,
  user_title,
  user_setor,
  // user_time,
}) {
  const [showVideo, setShowVideo] = useState(false);
  function toggleVideo() {
    setShowVideo(true);
  }
  return (
    <Container>
      <Inner>
        <Image
          onClick={toggleVideo}
          className={showVideo ? 'show-video' : 'hide-video'}
        >
          {showVideo ? (
            <iframe
              width="100%"
              height="100%"
              src={`https://www.youtube.com/embed/${video}`}
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              autoPlay="true"
              title="Video"
            ></iframe>
          ) : (
            <img
              src={
                img_video
                  ? img_video
                  : `https://img.youtube.com/vi/${video}/maxresdefault.jpg`
              }
              alt={text}
            />
          )}
          {/* <img
            src={`https://img.youtube.com/vi/${video}/maxresdefault.jpg`}
            alt={text}
          /> */}
        </Image>
        {/* <Text>{text}</Text> */}
        <User>
          <img src={user} alt={text} />
          <div>
            <h3>{user_title}</h3>
            <p>{user_setor}</p>
          </div>
          {/* <span>{user_time}</span> */}
        </User>
      </Inner>
    </Container>
  );
}

Section05VideoItem.propTypes = {
  video: PropTypes.string,
  img_video: PropTypes.string,
  text: PropTypes.string,
  user: PropTypes.string,
  user_title: PropTypes.string,
  user_setor: PropTypes.string,
  user_time: PropTypes.string,
};
